// Helpers compartilhados pelos dois fluxos de consentimento administrativo:
// o onboarding do tenant (OnboardingScreen) e a renovação de permissões
// (PermissionsRenewalScreen). Ambos usam o mesmo popup (public/onboarding-popup.html).

import { getRuntimeEnv } from "../config/runtimeEnv";

const apiBaseUrl = (getRuntimeEnv("REACT_APP_TEAMS_BOT_API_BASE_URL") || "").trim();
const onboardingRedirectUri = (getRuntimeEnv("REACT_APP_ONBOARDING_REDIRECT_URI") || "").trim();

export type OnboardingQueryState = {
  adminConsent: string;
  error: string;
  errorDescription: string;
  errorUri: string;
  hasConsentParam: boolean;
  hasError: boolean;
  scope: string;
  state: string;
  tenant: string;
};

export function resolveBaseUrl(): string {
  if (apiBaseUrl) {
    return apiBaseUrl.replace(/\/+$/, "");
  }

  if (typeof window === "undefined") {
    return "";
  }

  return window.location.origin;
}

export function buildApiUrl(pathname: string): string {
  const baseUrl = resolveBaseUrl();
  if (!baseUrl) {
    return pathname;
  }

  return `${baseUrl}${pathname.startsWith("/") ? pathname : `/${pathname}`}`;
}

export function parseOnboardingQuery(search = typeof window !== "undefined" ? window.location.search : ""): OnboardingQueryState {
  const params = new URLSearchParams(search);

  return {
    adminConsent: (params.get("admin_consent") || "").toLowerCase(),
    error: params.get("error") || "",
    errorDescription: params.get("error_description") || "",
    errorUri: params.get("error_uri") || "",
    hasConsentParam: params.has("admin_consent"),
    hasError: params.has("error"),
    scope: params.get("scope") || "",
    state: params.get("state") || "",
    tenant: params.get("tenant") || "",
  };
}

export function clearBrowserQuery() {
  if (typeof window === "undefined") {
    return;
  }

  const nextUrl = `${window.location.pathname}${window.location.hash}`;
  window.history.replaceState({}, document.title, nextUrl);
}

export function buildPopupUrl(): string {
  if (onboardingRedirectUri) {
    return onboardingRedirectUri;
  }

  const baseUrl = resolveBaseUrl();
  if (!baseUrl) {
    return "/onboarding-popup.html";
  }

  return `${baseUrl}/onboarding-popup.html`;
}

// Do corpo de erro só o campo `message` é aproveitado. O corpo cru (JSON completo, página
// HTML de um proxy, texto de erro de rede) nunca é exibido: mensagens vindas da rede já
// expuseram a URL do PABX com o token na tela do usuário.
export async function readResponseError(response: Response): Promise<string> {
  const statusLine = `${response.status} ${response.statusText}`;
  const responseText = await response.text();
  if (!responseText) {
    return statusLine;
  }

  try {
    const parsed = JSON.parse(responseText) as { message?: unknown };
    return typeof parsed.message === "string" && parsed.message.trim() ? parsed.message.trim() : statusLine;
  } catch {
    return statusLine;
  }
}
